import styled from "styled-components";

export const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 0 50px;
  @media screen and (max-width: 480px) {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;
export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 130px);
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 480px) {
    height: calc(100vh - 80px);
  }
`;

export const Main = styled.div`
  width: 70%;
  display: flex;
  @media screen and (max-width: 480px) {
    width: 80%;
    flex-direction: column;
  }
`;

export const Left = styled.div`
  width: 50%;
  @media screen and (max-width: 480px) {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
  }
`;

export const ImageHolder = styled.div`
  position: relative;
  width: 70%;
  height: 100%;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);

  ::before {
    content: "";
    position: absolute;
    top: 30px;
    left: -30px;
    right: 30px;
    bottom: -30px;
    z-index: -1;
    border: 2px solid #837878e8;
  }

  ::after {
    content: "";
    position: absolute;
    top: -30px;
    left: 30px;
    right: -30px;
    bottom: 30px;
    z-index: -1;
    border: 2px solid #837878e8;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Right = styled.div`
  width: 50%;
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;
export const Greeting = styled.p`
  font-size: 18px;
  font-weight: 200;
  font-style: italic;
  margin-bottom: 5px;
  @media screen and (max-width: 480px) {
    font-size: 11px;
    font-weight: 400;
  }
`;
export const Name = styled.p`
  font-size: 35px;
  margin-bottom: 10px;
  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;
export const Desc = styled.p`
  font-size: 16px;
  font-weight: 300;
  text-align: justify;
  text-justify: inter-word;
  @media screen and (max-width: 480px) {
    font-size: 11px;
    font-weight: 500;
  }
`;
